import {ErrorMessage, Formik} from 'formik';
import PropTypes from 'prop-types';
import React, {useCallback} from 'react';
import {confirmable, createConfirmation} from 'react-confirm';
import BasicButton from '../../../../components/BasicButton';
import BasicButtonGroup from '../../../../components/BasicButtonGroup';
import BasicInput from '../../../../components/BasicInput';
import BasicSubmitButton from '../../../../components/BasicSubmitButton';
import LoadMask from '../../../../components/LoadMask';
import './styles.css';
import Popup from '../../../../components/Popup';
import ENDPOINT from '../../../../constants/endpoints';
import UxHelpers from '../../../../helpers/ux-helpers';
import useApi from '../../../../hooks/useApi';
import ResponseErrorDialog from '../ResponseErrorDialog';
import {UpdateBillingValidationSchema} from './validate';

const UpdateBillingDialog = props => {
  const {
    show,
    proceed,
    dismiss,
    cancel,
    data,
    title,
    modeless,
    dismissWhenClose,
    hasCloseButton,
    popupStyles,
    className,
  } = props;
  const api = useApi();

  const onSubmit = useCallback((values, { setSubmitting }) => {
    api.post(ENDPOINT.ACTION.ACCOUNT.UPDATE_BILLING_INFO, values, {
      handleError: response => ResponseErrorDialog({ response }),
      handleSuccess: (response) => {
        proceed(response);
        UxHelpers.overflowLock('unlock');
      },
      handleComplete: () => setSubmitting(false),
    });
  }, []);

  return (
    show && (
      <Popup
        title={title}
        actions={{
          dismiss,
          cancel,
        }}
        popupStyles={popupStyles}
        bodyRender={(
          <Formik
            initialValues={{
              email: data.email,
              name: data.name,
            }}
            validationSchema={UpdateBillingValidationSchema}
            onSubmit={onSubmit}
          >
            {({
                values,
                errors,
                touched,
                handleChange,
                handleBlur,
                handleSubmit,
                isSubmitting,
              }) => (
              <form onSubmit={handleSubmit} id={'update-billing-form'} className="form__content update-billing-form">
                {isSubmitting && <LoadMask/>}
                <div className="form__group form__group--compact">
                  <BasicInput
                    label="Email"
                    required={true}
                    name="email"
                    inputType="email"
                    content={values.email}
                    placeholder="my@email.com"
                    controlFunc={handleChange}
                    isValid={(!errors.email && touched.email) || !touched.email}
                    touchFunc={handleBlur}
                    labelStyles={{fontWeight: 'bold'}}
                  />

                  <ErrorMessage
                    name="email"
                    render={message => (
                      <div className="form__error">{message}</div>
                    )}
                  />
                </div>
                <div className="form__group form__group--compact">
                  <BasicInput
                    label="Name"
                    required={true}
                    name="name"
                    inputType="text"
                    content={values.name}
                    placeholder="Jane Doe"
                    controlFunc={handleChange}
                    isValid={(!errors.name && touched.name) || !touched.name}
                    touchFunc={handleBlur}
                    labelStyles={{fontWeight: 'bold'}}
                  />

                  <ErrorMessage
                    name="name"
                    render={message => (
                      <div className="form__error">{message}</div>
                    )}
                  />
                </div>
                <div className="form__controls form__controls--compact">
                  <BasicButtonGroup
                    groupStyles={{width: '100%', justifyContent: 'center'}}
                  >
                    <BasicButton
                      controlFunc={dismiss}
                      btnWidth={200}
                      btnHeight={40}
                      btnFontWeight={500}
                      btnArrow={false}
                      btnTextColor="#27282d"
                      btnText="Cancel"
                    />
                    <BasicSubmitButton
                      btnWidth={200}
                      btnHeight={40}
                      btnFontWeight={500}
                      btnArrow={false}
                      btnTextColor="#27282d"
                      btnText="Update"
                    />
                  </BasicButtonGroup>
                </div>
              </form>
            )}
          </Formik>
        )}
        modeless={modeless}
        dismissWhenClose={dismissWhenClose}
        hasCloseButton={hasCloseButton}
        className={className}
      />
    )
  );
};

UpdateBillingDialog.propTypes = {
  title: PropTypes.string,
  modeless: PropTypes.bool,
  dismissWhenClose: PropTypes.bool,
  textSuccessBtn: PropTypes.string,
  textCancelBtn: PropTypes.string,
  className: PropTypes.string,
};

export default createConfirmation(confirmable(UpdateBillingDialog));
